import type { DataProvider } from '@refinedev/core';
import { api } from '@/api/axios';
import queryString from 'query-string';

export const dataProvider: DataProvider = {
  getList: async ({ resource, pagination, sorters, filters }) => {
    const { current = 1, pageSize = 10 } = pagination ?? {};
    const query: Record<string, unknown> = { page: current, page_size: pageSize };
    if (sorters?.length) {
      query.sort_by = sorters[0].field;
      query.sort_desc = sorters[0].order === 'desc';
    }
    filters?.forEach(filter => {
      if (filter.operator === 'eq') query[filter.field] = filter.value;
      else if (filter.operator === 'contains') query.search = filter.value;
    });
    const { data } = await api.get(`/${resource}?${queryString.stringify(query)}`);
    return { data: data.data || [], total: data.total || 0 };
  },
  getOne: async ({ resource, id }) => {
    const { data } = await api.get(`/${resource}/${id}`);
    return { data: data.data || data };
  },
  create: async ({ resource, variables }) => {
    const { data } = await api.post(`/${resource}`, variables);
    return { data: data.data || data };
  },
  update: async ({ resource, id, variables }) => {
    const { data } = await api.put(`/${resource}/${id}`, variables);
    return { data: data.data || data };
  },
  deleteOne: async ({ resource, id }) => {
    const { data } = await api.delete(`/${resource}/${id}`);
    return { data: data.data || data };
  },
  getApiUrl: () => api.defaults.baseURL || '',
  getMany: async ({ resource, ids }) => {
    const { data } = await api.get(`/${resource}?${queryString.stringify({ ids })}`);
    return { data: Array.isArray(data) ? data : data.data || [] };
  },
  createMany: async ({ resource, variables }) => {
    const { data } = await api.post(`/${resource}/bulk`, { items: variables });
    return { data: Array.isArray(data) ? data : data.data || [] };
  },
  updateMany: async ({ resource, ids, variables }) => {
    const { data } = await api.patch(`/${resource}/bulk`, { ids, variables });
    return { data: Array.isArray(data) ? data : data.data || [] };
  },
  deleteMany: async ({ resource, ids }) => {
    const { data } = await api.delete(`/${resource}/bulk`, { data: { ids } });
    return { data: Array.isArray(data) ? data : data.data || [] };
  },
};
